export const HeaderSettings = [
  { key: "profile", text: "Profile" },
  { key: "dashboard", text: "Dashboard" },
  { key: "logout", text: "Logout" },
];
